export function hairMBTI() {
  return {
    currentScreen: 'quiz',
    currentQuestion: 0,
    answers: [],
    result: {
      type: '',
      title: '',
      subtitle: '',
      description: '',
      traits: [],
      recommendation: '',
    },
    questions: [
      // E vs I (외향/내향)
      {
        question: '미용실에 들어설 때 당신은?',
        optionA: '디자이너님께 반갑게 먼저 인사하고 오늘 기분을 이야기한다',
        optionB: '예약 확인 후 조용히 안내를 기다린다',
        dimension: 'EI',
      },
      {
        question: '시술 중 거울 속의 나는?',
        optionA: '디자이너님과 수다 떠는 게 즐겁다',
        optionB: '눈을 감고 쉬거나 조용히 스마트폰을 본다',
        dimension: 'EI',
      },
      {
        question: '새로운 미용실을 찾을 때?',
        optionA: '친구 추천이나 SNS 후기를 적극적으로 찾아본다',
        optionB: '혼자 조용히 검색하고 신중하게 결정한다',
        dimension: 'EI',
      },

      // S vs N (감각/직관)
      {
        question: '스타일을 결정할 때 나는?',
        optionA: '요즘 유행하는 스타일을 추천받는다',
        optionB: '미리 찾아온 레퍼런스 사진을 보여주며 상세히 설명한다',
        dimension: 'SN',
      },
      {
        question: '헤어스타일 변화에 대한 생각은?',
        optionA: '지금 당장 예쁘면 된다! 실용적인 게 최고',
        optionB: '3개월 후 내 모습까지 상상하며 전체적인 이미지를 고려한다',
        dimension: 'SN',
      },
      {
        question: '염색할 때 중요한 것은?',
        optionA: '지금 내 피부톤과 잘 어울리는 색상',
        optionB: '계절이 바뀌어도 어울릴 전체적인 분위기와 컨셉',
        dimension: 'SN',
      },
      {
        question: '디자이너의 제안을 들을 때?',
        optionA: '구체적인 길이, 컬의 정도 등 세부사항이 궁금하다',
        optionB: '전체적인 느낌과 이미지 변화가 궁금하다',
        dimension: 'SN',
      },

      // T vs F (사고/감정)
      {
        question: '헤어스타일이 마음에 안 들 때?',
        optionA: '객관적으로 어떤 부분이 마음에 안 드는지 정확히 말한다',
        optionB: '디자이너님 기분 상할까봐 괜찮다고 말하고 집에 가서 고민한다',
        dimension: 'TF',
      },
      {
        question: '미용실을 선택하는 기준은?',
        optionA: '실력, 가격, 위치 등 객관적 조건을 따진다',
        optionB: '분위기가 편안하고 디자이너와 잘 맞는지가 중요하다',
        dimension: 'TF',
      },
      {
        question: '시술 시간이 예상보다 길어지면?',
        optionA: '다음 스케줄을 확인하고 정확한 소요 시간을 묻는다',
        optionB: '괜찮다고 말하며 디자이너님의 수고를 이해한다',
        dimension: 'TF',
      },

      // J vs P (판단/인식)
      {
        question: '미용실 예약은?',
        optionA: '최소 일주일 전에 미리 예약한다',
        optionB: '당일이나 하루 전에 급하게 예약한다',
        dimension: 'JP',
      },
      {
        question: '시술 전 준비는?',
        optionA: '하고 싶은 스타일 사진을 미리 여러 장 저장해둔다',
        optionB: '그때그때 디자이너님과 상담하며 즉흥적으로 결정한다',
        dimension: 'JP',
      },
      {
        question: '헤어스타일 관리는?',
        optionA: '정해진 루틴대로 꼼꼼히 관리한다',
        optionB: '그날그날 기분이나 상황에 따라 유연하게 한다',
        dimension: 'JP',
      },
      {
        question: '새로운 스타일 제안을 받으면?',
        optionA: '신중하게 고민하고 다음 방문 때 시도할지 결정한다',
        optionB: '재밌을 것 같으면 바로 시도해본다',
        dimension: 'JP',
      },
    ],
    results: {
      // 16가지 유형
      ESTJ: {
        type: 'ESTJ',
        title: '완벽주의 헤어 매니저',
        subtitle: '체계적이고 실용적인 당신',
        description:
          '효율적이고 실용적인 스타일을 선호하는 당신은 관리가 쉽고 깔끔한 헤어를 원합니다. 트렌드보다는 자신에게 잘 어울리는 검증된 스타일을 고집하며, 정확한 소통을 통해 원하는 결과를 얻어냅니다.',
        traits: [
          '명확한 스타일 요구사항을 가지고 있음',
          '실용성과 관리 용이성을 최우선으로 고려',
          '정해진 미용실과 디자이너를 꾸준히 이용',
          '시간 약속을 철저히 지킴',
        ],
        recommendation:
          '단정하고 세련된 보브컷이나 레이어드 컷이 잘 어울립니다. 관리가 간편하면서도 전문적인 이미지를 주는 스타일을 추천드립니다.',
      },
      ESFJ: {
        type: 'ESFJ',
        title: '친화력 만점 인싸형',
        subtitle: '따뜻하고 사교적인 당신',
        description:
          '주변 사람들과의 조화를 중요하게 생각하는 당신은 디자이너와의 관계를 소중히 여기며, 유행하는 스타일 중에서도 자신에게 어울리는 것을 찾습니다. 편안한 분위기에서 대화를 즐기며 시술받는 것을 좋아합니다.',
        traits: [
          '디자이너와 친밀한 관계 형성',
          '주변 사람들의 의견을 적극 수렴',
          '트렌디하면서도 대중적인 스타일 선호',
          '정기적인 관리와 방문을 중요시',
        ],
        recommendation:
          '부드러운 웨이브 펌이나 자연스러운 염색이 잘 어울립니다. 사람들에게 친근하고 따뜻한 인상을 주는 스타일을 추천합니다.',
      },
      ISTJ: {
        type: 'ISTJ',
        title: '확신의 소나무형',
        subtitle: '신중하고 전통적인 당신',
        description:
          '자신만의 확고한 스타일이 있는 당신은 검증된 디자이너와 익숙한 스타일을 선호합니다. 무리한 변화보다는 꾸준한 관리를 통해 최상의 상태를 유지하는 것을 중요하게 생각합니다.',
        traits: [
          '오랜 시간 한 디자이너를 신뢰',
          '급격한 변화보다 점진적 개선 선호',
          '1mm까지 정확한 디테일 요구',
          '예약 시간을 철저히 준수',
        ],
        recommendation:
          '클래식한 스트레이트나 단정한 단발이 잘 어울립니다. 시간이 지나도 변하지 않는 우아한 스타일을 추천드립니다.',
      },
      ISFJ: {
        type: 'ISFJ',
        title: '인간 에어컨형',
        subtitle: '조용한 휴식이 필요한 당신',
        description:
          '미용실을 휴식의 공간으로 여기는 당신은 섬세한 손길과 편안한 분위기를 중요하게 생각합니다. 디자이너의 배려 있는 서비스에 감사하며, 자신에게 잘 어울리는 무난한 스타일을 선호합니다.',
        traits: [
          '조용하고 편안한 시술 환경 선호',
          '디자이너의 섬세한 배려에 감동',
          '안정적이고 부담 없는 스타일 추구',
          '정기적이고 꾸준한 관리',
        ],
        recommendation:
          '자연스러운 긴 생머리나 부드러운 레이어드 컷이 잘 어울립니다. 편안하고 우아한 분위기의 스타일을 추천합니다.',
      },
      ESTP: {
        type: 'ESTP',
        title: '트렌드 세터형',
        subtitle: '변신을 두려워하지 않는 당신',
        description:
          '새로운 스타일에 과감하게 도전하는 당신은 트렌드를 빠르게 받아들이고 실험적인 변화를 즐깁니다. 즉흥적이고 대담한 결정으로 인생 머리를 만들어냅니다.',
        traits: [
          '유행 스타일을 빠르게 시도',
          '과감한 변신을 두려워하지 않음',
          '즉흥적인 결정을 즐김',
          '새로운 디자이너 경험을 선호',
        ],
        recommendation:
          '대담한 숏컷이나 강렬한 컬러 염색이 잘 어울립니다. 개성 넘치고 눈에 띄는 스타일을 추천드립니다.',
      },
      ESFP: {
        type: 'ESFP',
        title: '비타민 에너지형',
        subtitle: '즐거움이 가득한 당신',
        description:
          '미용실 방문 자체를 즐기는 당신은 밝고 긍정적인 에너지로 분위기를 밝힙니다. 자신을 표현하는 화려한 스타일을 좋아하며, 디자이너와의 대화를 통해 영감을 얻습니다.',
        traits: [
          '밝고 활기찬 분위기 조성',
          '화려하고 눈에 띄는 스타일 선호',
          '디자이너와 즐거운 대화',
          '즉흥적이고 자유로운 스타일 변화',
        ],
        recommendation:
          '볼륨감 있는 웨이브나 밝은 톤의 염색이 잘 어울립니다. 생동감 넘치고 활기찬 스타일을 추천합니다.',
      },
      ISTP: {
        type: 'ISTP',
        title: '쿨한 개인주의자',
        subtitle: '실용성을 추구하는 당신',
        description:
          '불필요한 대화보다 실질적인 결과를 중시하는 당신은 관리가 편하고 자신의 라이프스타일에 맞는 스타일을 선택합니다. 독립적이고 자유로운 성향으로 유행에 구애받지 않습니다.',
        traits: [
          '최소한의 관리로 최대 효과 추구',
          '조용하고 효율적인 시술 선호',
          '유행보다 개인 취향 우선',
          '실용성 중심의 스타일 결정',
        ],
        recommendation:
          '간결한 숏컷이나 스타일링이 쉬운 매쉬 컷이 잘 어울립니다. 심플하면서 개성 있는 스타일을 추천드립니다.',
      },
      ISFP: {
        type: 'ISFP',
        title: '감성 아티스트',
        subtitle: '예술적 감각의 당신',
        description:
          '자신만의 독특한 미적 감각을 가진 당신은 헤어스타일을 예술작품처럼 여깁니다. 유행보다는 자신의 개성과 감성을 표현하는 스타일을 추구하며, 디자이너의 창의성을 존중합니다.',
        traits: [
          '독창적이고 예술적인 스타일 추구',
          '색감과 질감에 민감함',
          '디자이너의 창의적 제안 수용',
          '자신만의 독특한 아우라 중시',
        ],
        recommendation:
          '독특한 컬러 조합이나 비대칭 컷이 잘 어울립니다. 예술적이고 감각적인 스타일을 추천합니다.',
      },
      ENTJ: {
        type: 'ENTJ',
        title: '카리스마 리더형',
        subtitle: '강렬한 인상의 당신',
        description:
          '명확한 목표와 비전을 가진 당신은 자신의 이미지를 전략적으로 관리합니다. 전문적이고 세련된 스타일을 통해 리더십을 표현하며, 효율적인 소통으로 원하는 결과를 얻어냅니다.',
        traits: [
          '명확한 이미지 전략 수립',
          '전문적이고 카리스마 있는 스타일 선호',
          '효율적이고 논리적인 의사소통',
          '장기적인 헤어 관리 계획',
        ],
        recommendation:
          '강렬한 단발이나 시크한 슬릭백 스타일이 잘 어울립니다. 프로페셔널하고 강인한 이미지의 스타일을 추천드립니다.',
      },
      ENFJ: {
        type: 'ENFJ',
        title: '영감을 주는 뮤즈형',
        subtitle: '사람들에게 영향을 주는 당신',
        description:
          '타인에게 긍정적인 영향을 미치는 것을 중요하게 생각하는 당신은 조화롭고 세련된 스타일로 좋은 인상을 남깁니다. 디자이너와의 깊은 교감을 통해 최상의 결과를 만들어냅니다.',
        traits: [
          '조화롭고 우아한 이미지 추구',
          '디자이너와의 깊은 소통',
          '타인에게 좋은 인상을 주는 스타일',
          '트렌드와 개성의 균형',
        ],
        recommendation:
          '우아한 롱 웨이브나 여성스러운 미디엄 컷이 잘 어울립니다. 세련되고 친근한 분위기의 스타일을 추천합니다.',
      },
      INTJ: {
        type: 'INTJ',
        title: '전략적 완벽주의자',
        subtitle: '치밀한 계획의 당신',
        description:
          '모든 것을 체계적으로 계획하는 당신은 헤어스타일도 전략적으로 접근합니다. 장기적인 관점에서 자신에게 최적화된 스타일을 찾아내며, 독립적이고 자신감 있는 이미지를 선호합니다.',
        traits: [
          '철저한 사전 조사와 계획',
          '논리적이고 체계적인 스타일 선택',
          '독창적이면서 실용적인 균형',
          '장기적 관점의 헤어 관리',
        ],
        recommendation:
          '미니멀한 보브나 정돈된 레이어드 컷이 잘 어울립니다. 지적이고 세련된 이미지의 스타일을 추천드립니다.',
      },
      INFJ: {
        type: 'INFJ',
        title: '신비로운 이상주의자',
        subtitle: '깊이 있는 내면의 당신',
        description:
          '자신만의 독특한 세계관을 가진 당신은 헤어스타일을 통해 내면의 아름다움을 표현합니다. 의미와 스토리가 있는 스타일을 선호하며, 디자이너와의 진정성 있는 소통을 중요시합니다.',
        traits: [
          '의미 있는 스타일 변화 추구',
          '내면의 가치를 반영한 외적 표현',
          '디자이너와의 깊은 이해와 신뢰',
          '독창적이면서 조화로운 스타일',
        ],
        recommendation:
          '자연스러운 긴 생머리나 우아한 레이어 컷이 잘 어울립니다. 신비롭고 고요한 아름다움의 스타일을 추천합니다.',
      },
      ENTP: {
        type: 'ENTP',
        title: '실험적 혁신가',
        subtitle: '창의적 도전을 즐기는 당신',
        description:
          '새로운 것을 시도하는 것을 두려워하지 않는 당신은 헤어스타일로 자신의 창의성을 표현합니다. 디자이너와 함께 혁신적인 스타일을 만들어내며, 예상치 못한 변화를 즐깁니다.',
        traits: [
          '실험적이고 독창적인 스타일 시도',
          '디자이너와의 창의적 협업',
          '트렌드를 넘어선 혁신 추구',
          '즉흥적이고 대담한 변신',
        ],
        recommendation:
          '비대칭 컷이나 독특한 언더컷이 잘 어울립니다. 파격적이고 창의적인 스타일을 추천드립니다.',
      },
      ENFP: {
        type: 'ENFP',
        title: '자유로운 영혼',
        subtitle: '끊임없이 변화하는 당신',
        description:
          '자유롭고 창의적인 당신은 헤어스타일을 통해 다양한 자신의 모습을 표현합니다. 매번 새로운 스타일에 도전하며, 긍정적인 에너지로 디자이너에게도 영감을 줍니다.',
        traits: [
          '다채로운 스타일 변화 즐김',
          '밝고 긍정적인 에너지',
          '디자이너의 창의적 제안 환영',
          '자유로운 자기 표현',
        ],
        recommendation:
          '컬러풀한 옴브레나 활기찬 컬 펌이 잘 어울립니다. 생기발랄하고 자유로운 스타일을 추천합니다.',
      },
      INTP: {
        type: 'INTP',
        title: '논리적 분석가',
        subtitle: '이성적으로 접근하는 당신',
        description:
          '모든 것을 논리적으로 분석하는 당신은 헤어스타일도 과학적으로 접근합니다. 얼굴형, 두상, 모발 상태 등을 분석하여 최적의 스타일을 찾아내며, 효율성을 중시합니다.',
        traits: [
          '논리적이고 분석적인 스타일 선택',
          '과학적 근거 기반 의사결정',
          '최소 관리로 최대 효과',
          '독립적이고 개성 있는 선택',
        ],
        recommendation:
          '구조적인 숏컷이나 기하학적 보브가 잘 어울립니다. 논리적이면서 독특한 스타일을 추천드립니다.',
      },
      INFP: {
        type: 'INFP',
        title: '몽환적 낭만주의자',
        subtitle: '꿈꾸는 당신',
        description:
          '이상적인 아름다움을 추구하는 당신은 헤어스타일을 통해 자신만의 세계를 표현합니다. 낭만적이고 감성적인 스타일을 선호하며, 디자이너와의 공감을 중요하게 생각합니다.',
        traits: [
          '낭만적이고 감성적인 스타일',
          '자신만의 독특한 미적 가치',
          '디자이너와의 정서적 교감',
          '개성과 조화의 균형',
        ],
        recommendation:
          '부드러운 웨이브나 자연스러운 긴 머리가 잘 어울립니다. 몽환적이고 로맨틱한 스타일을 추천합니다.',
      },
    },

    get progress() {
      return ((this.currentQuestion + 1) / this.questions.length) * 100;
    },
    startQuiz() {
      this.currentScreen = 'quiz';
    },

    selectAnswer(answer) {
      this.answers[this.currentQuestion] = answer;
      setTimeout(() => this.nextQuestion(), 100);
    },

    nextQuestion() {
      if (this.currentQuestion < this.questions.length - 1) {
        this.currentQuestion++;
      } else {
        this.calculateResult();
      }
    },

    prevQuestion() {
      if (this.currentQuestion > 0) {
        this.currentQuestion--;
      }
    },

    calculateResult() {
      this.currentScreen = 'calculating';

      setTimeout(() => {
        let scores = { E: 0, I: 0, S: 0, N: 0, T: 0, F: 0, J: 0, P: 0 };

        this.questions.forEach((question, index) => {
          const answer = this.answers[index];
          const dimension = question.dimension;

          if (dimension === 'EI') {
            answer === 'A' ? scores.E++ : scores.I++;
          } else if (dimension === 'SN') {
            answer === 'A' ? scores.S++ : scores.N++;
          } else if (dimension === 'TF') {
            answer === 'A' ? scores.T++ : scores.F++;
          } else if (dimension === 'JP') {
            answer === 'A' ? scores.J++ : scores.P++;
          }
        });

        const mbtiType =
          (scores.E >= scores.I ? 'E' : 'I') +
          (scores.S >= scores.N ? 'S' : 'N') +
          (scores.T >= scores.F ? 'T' : 'F') +
          (scores.J >= scores.P ? 'J' : 'P');

        this.result = this.results[mbtiType];
        this.currentScreen = 'result';
      }, 2000);
    },

    restart() {
      this.currentScreen = 'intro';
      this.currentQuestion = 0;
      this.answers = [];
      this.result = {
        type: '',
        title: '',
        subtitle: '',
        description: '',
        traits: [],
        recommendation: '',
      };
    },
  };
}
